import React, { useState, memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { constant, each, mapObject, omit } from 'underscore';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { BackboneInstanceWrapper } from '@bingads-webui-react/backbone-instance-wrapper';

import { getStyles } from './styles/index';

export const GridViewWrapper = ({
  gridView: gridViewFromProps,
  gridEventHandlers: gridEventHandlersFromProps,
  removeGridOnUmount,
  getReferenceToGridView,
  classes,
  children,
  gridClassName,
}) => {
  // Store the backbone grid and handler instances and ignore all subsequent updates.
  const [gridView] = useState(gridViewFromProps);
  const [gridEventHandlers] = useState(gridEventHandlersFromProps);

  if (getReferenceToGridView) {
    getReferenceToGridView(gridView);
  }

  useEffect(() => () => {
    if (removeGridOnUmount && gridView.remove) {
      gridView.remove();
    }
  }, [removeGridOnUmount, gridView]);

  each(gridEventHandlers.once, (handler, event) => {
    gridView.once(event, handler);
  });

  each(gridEventHandlers.on, (handler, event) => {
    gridView.on(event, handler);
  });

  return (
    <div className={classes.grid}>
      {gridView &&
        <div className={gridClassName}>
          <BackboneInstanceWrapper
            managed
            instance={gridView.render()}
          />
        </div>
      }
      {children}
    </div>
  );
};

GridViewWrapper.propTypes = {
  classes: PropTypes.shape(mapObject(
    omit(getStyles({}, {}), '@global'),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  gridView: PropTypes.shape({
    render: PropTypes.func,
  }),
  children: PropTypes.node,
  gridClassName: PropTypes.string,
  gridEventHandlers: PropTypes.shape({
    once: PropTypes.objectOf(PropTypes.func),
    on: PropTypes.objectOf(PropTypes.func),
  }),
  getReferenceToGridView: PropTypes.func,
  removeGridOnUmount: PropTypes.bool,
};

GridViewWrapper.defaultProps = {
  gridEventHandlers: {
    once: {},
    on: {},
  },
  getReferenceToGridView: null,
  removeGridOnUmount: false,
  gridView: null,
  children: null,
  gridClassName: 'bingadsgrid',
};

export const StyledGridViewWrapper = withDefaultStyles(memo(GridViewWrapper), getStyles);
